import React, { useState, useEffect, Component } from "react";
import moment from "moment/moment";
import { RiRefreshLine } from "react-icons/ri";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ClipLoader } from 'react-spinners';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import WindowedSelect from 'react-windowed-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { toast } from "react-toastify";
import { MdEdit, MdDelete } from "react-icons/md";
import { useSelector } from 'react-redux';
import { getName } from '../../../Redux/selecters';

const Survey = ({ isEditData, setIsEditData, getItems, setIsEdit, isEdit, statusLIst, listProperty, customerList, scheduleList, agentList, setSurveeyList, surveyList, setVisitor, visitor }) => {
    const apiService = new LeaseApiService();
    const [loading, setloader] = useState(false);
    const [FilterTab, setFilterTab] = useState(true);
    const [unitList, setUnitList] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const fulname = useSelector(getName);

    const ITEMS_PER_PAGE = 100

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const [details, setDetails] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        agent: [{ label: 'Select Agent', value: '' }],
        status: [{ label: 'Select Status', value: '' }],
        date: "",
        from: "",
        to: "",
        remarks: "",
    });

    useEffect(() => {
        const today = new Date();
        let todate = formatDate(today)
        setDetails((prev) => ({ ...prev, date: todate }));
    }, []);

    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setDetails({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            agent: [{ label: 'Select Agent', value: '' }],
            status: [{ label: 'Select Status', value: '' }],
            date: todate,
            from: "",
            to: "",
            remarks: "",
        });
        setVisitor({
            name: [{ label: 'Select', value: '' }],
            contact: [{ label: 'Select', value: '' }],
            phone: "",
            email: "",
            sms: "",
            data: {},
            cc: "",
        });
        setIsEdit(false);
        setSurveeyList([]);
        setIsEditData(null)
        setEditIndex(null);
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "Proprty" && !value) {
            // property cleared: drop the unit selection and its list
            setUnitList([]);
            setDetails(prev => ({ ...prev, Proprty: null, unitNo: null }));
            return;
        }
        if (name === "Proprty") {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'PTSearchUnitNosByPropertyId');
            params.append('CascadValue', value?.value);
            const res = await apiService.getApiParamater('CASCAD_PROPRTYTOUR', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
        }
        setDetails(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...details, [name]: updatedValue };
        setDetails(updatedDates);
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDetails(prev => ({ ...prev, [name]: value }));
    }
    const handleInputVisitChange = (e) => {
        const { name, value } = e.target;
        setVisitor(prev => ({ ...prev, [name]: value }));
    }
    const handleVisitDropDownChange = async ({ name, value }) => {

        const params = new URLSearchParams();
        params.append("Action", "GetCustomerDetailsByTenantNo");
        params.append("TenantNo", value?.value?.value);
        const res = await apiService.getApiParamater("COMMON_PROPRTYTOUR", `?${params.toString()}`);
        let data = res?.data?.result?.data
        setVisitor(prev => ({
            ...prev,
            name: { label: data?.Customer_Name, value: value },
            contact: { label: data?.Customer_no, value: value },
            email: data?.Email_id,
            phone: data?.MainContactno,
            sms: "",
            cc: "",
            data: data,
        }));
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = customerList;

        if (search) {
            filtered = customerList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const loadOptionsID = (search, loadedOptions, { page }) => {
        let filtered = customerList;

        if (search) {
            filtered = customerList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.value })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const handleAdd = async () => {
        if (!details?.Proprty?.label || !details?.unitNo?.label) {
            toast.warning("Select Property and Unit");
            return;
        } else if (!details?.agent?.label) {
            toast.warning("Select Agent");
            return;
        } else if (!details?.status?.label) {
            toast.warning("Select Status");
            return;
        } else if (!details?.from) {
            toast.warning("Select From Time");
            return;
        } else if (!details?.to) {
            toast.warning("Select to Time");
            return;
        }

        const payload = {
            property: details?.Proprty?.label || "",
            unit: details?.unitNo?.label || "",
            date: details?.date ? moment(details.date).format("DD-MMM-YYYY") : "",
            from: details?.from || "",
            to: details?.to || "",
            agent: details?.agent?.label || "",
            status: details?.status?.label || "",
            remarks: details?.remarks || "",
            gmap: ""   // future use
        };

        if (isEdit) {
            // 🔁 EDIT MODE
            const body = {
                recordID: surveyList[0]?.recordId,
                schduleId: isEditData?.scheduleId,
                property: payload?.property,
                unit: payload?.unit,
                agent: payload?.agent,
                status: payload?.status,
                schDate: moment(payload?.date).format(),
                schFromTime: moment(payload?.from, "HH:mm").format("HH:mm:ss"),
                schToTime: moment(payload?.to, "HH:mm").format("HH:mm:ss"),
                modifiedBy: fulname,
                remarks: payload?.remarks
            };
            const postRes = await apiService.put('UPDATE_SCH_PROPRTYTOUR', body);
            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                toast.success(postRes?.data?.message || "Saved Successfully");
                getItems()
                const updatedList = [...surveyList];
                updatedList[editIndex] = payload;
                setSurveeyList(updatedList);
                const today = new Date();
                let todate = formatDate(today)
                setDetails({
                    Proprty: [{ label: 'Select Property', value: '' }],
                    unitNo: [{ label: 'Select Unit No', value: '' }],
                    agent: [{ label: 'Select Agent', value: '' }],
                    status: [{ label: 'Select Status', value: '' }],
                    date: todate,
                    from: "",
                    to: "",
                    remarks: "",
                });
                setEditIndex(null);
            } else {
                toast.warning(postRes?.data?.message || "Something went wrong");
                setloader(false);
            }


        } else {
            // ➕ ADD MODE
            setSurveeyList(prev => [...prev, payload]);
            toast.success("Schedule added successfully");
            const today = new Date();
            let todate = formatDate(today)
            setDetails({
                Proprty: [{ label: 'Select Property', value: '' }],
                unitNo: [{ label: 'Select Unit No', value: '' }],
                agent: [{ label: 'Select Agent', value: '' }],
                status: [{ label: 'Select Status', value: '' }],
                date: todate,
                from: "",
                to: "",
                remarks: "",
            });
        }
    };
    const handleDeleteRow = (index) => {
        setSurveeyList(prev => prev.filter((_, i) => i !== index));
    };
    const handleBackClick = () => {
        window.history.back();
    }
    const handleSave = async () => {
        try {
            setloader(true);

            if (!visitor?.name?.label) {
                toast.warning("Please Add Visitor Details");
                setloader(false);
                return;
            }

            if (!surveyList || surveyList.length === 0) {
                toast.warning("Please add at least one Schedule ");
                setloader(false);
                return;
            }

            const propertyDetailsList = surveyList.map((item) => {
                return {
                    property: item?.property || "",
                    unit: item?.unit || "",
                    agent: item?.agent || "",
                    status: item?.status || "",
                    schDate: moment(item?.date).format(),
                    schFromTime: moment(item?.from, "HH:mm").format("HH:mm:ss"),
                    schToTime: moment(item?.to, "HH:mm").format("HH:mm:ss"),
                    remarks: item?.remarks || ""
                };
            });


            const propertyTourRequest = {
                cont: visitor?.contact?.label || "0",
                custName: visitor?.data?.Customer_Name || visitor?.name?.label || "",
                email: visitor?.email || "",
                phone: visitor?.phone || "",
                sms: visitor?.sms || "",
                createdBy: fulname || "system"
            };

            const body = {
                leasePropertyTourMain: {
                    propertyDetailsList,
                    propertyTourRequest
                }
            };

            console.log("REQUEST BODY ===>", body);

            const postRes = await apiService.post('POST_PROPRTYTOUR', body);

            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                toast.success(postRes?.data?.message || "Saved Successfully");
                getItems()
                setloader(false);
                handleClearFilters()
            } else {
                toast.warning(postRes?.data?.message || "Something went wrong");
                setloader(false);
            }

        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
            toast.error("Save failed");
        } finally {
            setloader(false);
        }
    };
    const handleUpdate = async () => {
        try {
            setloader(true);

            if (!visitor?.name?.label) {
                toast.warning("Please Add Visitor Details");
                setloader(false);
                return;
            }
            const body = {
                editLeasePropertyTour: {
                    cont: visitor?.contact?.label || "0",
                    custName: visitor?.data?.Customer_Name || visitor?.name?.label || "",
                    email: visitor?.email || "",
                    phone: visitor?.phone || "",
                    sms: visitor?.sms || "",
                    createdBy: fulname || "system",
                    scheduleId: isEditData?.scheduleId,
                }
            };
            const postRes = await apiService.put('UPDATE_PROPRTYTOUR', body);

            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                toast.success(postRes?.data?.message || "Saved Successfully");
                getItems()
                setloader(false);
                handleClearFilters()
            } else {
                toast.warning(postRes?.data?.message || "Something went wrong");
                setloader(false);
            }

        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
            toast.error("Save failed");
        } finally {
            setloader(false);
        }
    };
    const isFieldDisabled = (fieldName) => {
        if (!isEdit) return false; // normal mode → all enabled
        // edit mode → only status & remarks allowed
        return !["status", "remarks"].includes(fieldName);
    };
    const normalizeTime = (time) => {
        if (!time) return "";
        // handles "10:30", "10:30:00", "10:30 AM"
        if (time.includes("AM") || time.includes("PM")) {
            return moment(time, ["hh:mm A"]).format("HH:mm");
        }
        if (time.length === 8) { // "HH:mm:ss"
            return moment(time, "HH:mm:ss").format("HH:mm");
        }
        return time; // already "HH:mm"
    };
    const handleEditRow = (rowData, index) => {
        setIsEdit(true);
        setEditIndex(index);

        setDetails({
            Proprty: { label: rowData.property, value: rowData.propertyId || rowData.property },
            unitNo: { label: rowData.unit, value: rowData.unitId || rowData.unit },
            agent: { label: rowData.agent, value: rowData.agentId || rowData.agent },
            status: { label: rowData.status, value: rowData.status },
            date: rowData.date,
            from: normalizeTime(rowData.from),   // ✅ FIX
            to: normalizeTime(rowData.to),
            remarks: rowData.remarks || "",
        });

        setFilterTab(true); // auto open form
    };
    return (
        <div className="mt-3">
            <div className='border-box2  p-2' style={{ borderRadius: "8px" }}>
                <div className='d-flex end gap-3'>
                    <div className='d-flex gap-2'>
                        {loading === true ?
                            <div className='mainbtn flex-end gap-2'>
                                <ClipLoader color="#ffffff" className='mt-1' size={25} />
                            </div>
                            :
                            <div className='mainbtn flex-end gap-2 ' onClick={isEdit === true ? handleUpdate : handleSave}>
                                <FaSave color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Save</div>
                            </div>
                        }
                    </div>
                    <div className='d-flex gap-2'>
                        <div className='mainbtnSecondary flex-end gap-2 ' onClick={handleBackClick}>
                            <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Back</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Visitor Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Name</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={visitor?.name}
                                    loadOptions={loadOptionsName}
                                    onChange={(selectedOption) => handleVisitDropDownChange({ name: 'name', value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Contact Id</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={visitor?.contact}
                                    loadOptions={loadOptionsID}
                                    onChange={(selectedOption) => handleVisitDropDownChange({ name: 'contact', value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Phone</label>
                                <input
                                    type="number"
                                    className="p-2 form-control w-75"
                                    name="phone"
                                    value={visitor.phone}
                                    onChange={handleInputVisitChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Email</label>
                                <input
                                    type="email"
                                    className="p-2 form-control w-75"
                                    name="email"
                                    value={visitor.email}
                                    onChange={handleInputVisitChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">SMS</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="sms"
                                    value={visitor.sms}
                                    onChange={handleInputVisitChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">CC</label>
                                <input
                                    type="text"
                                    className="form-control p-2 w-75"
                                    name="cc"
                                    value={visitor?.cc}
                                    onChange={handleInputVisitChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Schedule Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <WindowedSelect
                                    isClearable
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={details?.Proprty}
                                    isDisabled={isFieldDisabled("Proprty")}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'Proprty', value: selectedOption })}
                                    options={listProperty?.map(country => ({ value: country?.value, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit No</label>
                                <WindowedSelect
                                    isClearable
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={details?.unitNo}
                                    isDisabled={isFieldDisabled("unitNo")}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Agent</label>
                                <WindowedSelect
                                    isClearable
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={details?.agent}
                                    isDisabled={isFieldDisabled("agent")}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'agent', value: selectedOption })}
                                    options={agentList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={details.date}
                                    disabled={isFieldDisabled("date")}
                                    onChange={(date) => handleDateChange({ name: 'date', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">From</label>
                                <input
                                    type="time"
                                    className="p-2 form-control w-75"
                                    name="from"
                                    disabled={isFieldDisabled("from")}
                                    value={details.from}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">to</label>
                                <input
                                    type="time"
                                    className="p-2 form-control w-75"
                                    name="to"
                                    disabled={isFieldDisabled("to")}
                                    value={details.to}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Status</label>
                                <WindowedSelect
                                    isClearable
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={details?.status}
                                    isDisabled={isFieldDisabled("status")}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'status', value: selectedOption })}
                                    options={statusLIst?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Remarks</label>
                                <textarea
                                    type="text"
                                    className="form-control p-2 w-75"
                                    name="remarks"
                                    disabled={isFieldDisabled("remarks")}
                                    value={details?.remarks}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div></div>
                            <div className="d-flex gap-1">
                                {loading === true ?
                                    <div className='mainbtn flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div className='mainbtn flex-end gap-2 w-50' onClick={handleAdd}>
                                        <div className='center'>{isEdit ? "Update" : "+ Add"}</div>
                                    </div>

                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 p-3">
                <div className="border-box2 mt-2 p-1" style={{ borderRadius: '8px' }}>
                    <div className='table-container'>
                        <table className='table table-bordered gridshad'>
                            <thead className='dynoTable'>
                                <tr>
                                    <th>Action</th>
                                    <th>Property</th>
                                    <th>Unit</th>
                                    <th>Date</th>
                                    <th>Time From</th>
                                    <th>Time To</th>
                                    <th>Agent</th>
                                    <th>Status</th>
                                    <th>Remarks</th>
                                    <th>GMap Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {surveyList?.map((data, index) => (
                                    <tr key={index}>
                                        <td className="text-center d-flex gap-2 justify-content-center">
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={() => handleEditRow(data, index)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <MdEdit size={18} />
                                            </button>

                                            <button
                                                className="btn btn-sm btn-danger"
                                                disabled={isEdit === true}
                                                onClick={() => handleDeleteRow(index)}
                                                style={{ cursor: isEdit ? "not-allowed" : "pointer" }}
                                            >
                                                <MdDelete size={18} />
                                            </button>
                                        </td>
                                        <td><input className="form-control p-1" value={data.property} readOnly /></td>
                                        <td><input className="form-control p-1" value={data.unit} readOnly /></td>
                                        <td><input className="form-control p-1" value={data.date} readOnly /></td>
                                        <td><input className="form-control p-1" value={data.from} readOnly /></td>
                                        <td><input className="form-control p-1" value={data.to} readOnly /></td>
                                        <td><input className="form-control p-1" value={data.agent} readOnly /></td>
                                        <td><input className="form-control p-1" value={data.status} readOnly /></td>
                                        <td><input className="form-control p-1" value={data.remarks} readOnly /></td>
                                        <td>
                                            <input className="form-control p-1" value={data.gmap} readOnly />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div >
    );
};
export default Survey;
